<template>
    <div>
        <div>
            <ul class="nav nav-pills" role="tablist">
                <li v-if="user_data.pf" class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#user_data_pf" role="tab" aria-selected="false">
                        {{ $t('dashboard.label.payment_facilitator') }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div v-if="user_data.pf" id="user_data_pf" class="tab-pane active">
                <div class="panel panel-default mb-3">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-grass">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.daily_transactions') }}
                                        <h5 class="fix-margin">
                                            {{ user_data.pf.today_tr }}
                                            <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-oryelo">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.monthly_transactions') }}
                                        <h5 class="fix-margin">
                                            {{ user_data.pf.monthly_tr }}
                                            <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-bluvio">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.total_transactions') }}
                                        <h5 class="fix-margin">
                                            {{ user_data.pf.total_tr }}
                                            <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored ">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.balance') }}
                                        <h5 class="fix-margin">
                                            {{ user_data.pf.balance }}
                                            <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-midivio">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.settling_balance') }}
                                        <h5 class="fix-margin">
                                            {{ user_data.pf.settling }}
                                            <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-pinkp">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.settled_balance') }}
                                        <h5 class="fix-margin">
                                            {{ user_data.pf.settled }}
                                            <span style="font-size: 1.2rem">
                                                    {{' ' + $t('currency.rial')}}
                                                </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "user_datas",

        props: {
            user_data: {
                default() {
                    return {}
                }
            },
        },
        methods: {
            _countUserGate() {
                let count = 1;
                if (this.user_data.collective) {
                    count += 1;
                }
                if (this.user_data.ivr) {
                    count += 1;
                }
                if (this.user_data.dedicated) {
                    count += 1;
                }

                return count;
            }
        }
    }
</script>

<style>
.line-divider {
    height: 1px;
    background-color: #777;
}
</style>